import React, { useEffect, useState } from "react"
import { FACSearchBar } from "../search-bar/fac-search-bar"
import { ExportExcel } from "./excel-export"
import { PrintPdf } from "./print-pdf"
import { ContractorList } from "../contractor-card/contractor-list"
import { Map } from "../map/map"
import { ContactModal } from "../contact-modal/contact-modal"
import "../../assets/scss/styles.scss"
import ReactPaginate from "react-paginate"
import noresults from "../../assets/img/noresults.png"


export const SearchPage = ( {contractors, handleFilters, handleLocation, user, fullContractorList} ) => {
    // for search dropdown style
    const [ overlay, setOverlay ] = useState(false)
    // for contact-modal style and props
    const [ showModal, setShowModal ] = useState(false)
    const [ requestedContractor, setRequestedContractor ] = useState({})
    // for the pagination of the contractor list
    const [ pageCount, setPageCount] = useState(0)
    const [ itemsPerPage ] = useState(12)
    const [ currentItems, setCurrentItems] = useState(null)
    const [ noResultItems, setNoResultItems] = useState(null)
    const [ itemOffset, setItemOffset ] = useState(0)
    // for mobile views
    const [ showContractors, setShowContractors ] = useState(true)
    const [ showSearch, setShowSearch ] = useState(false)
    const [ showFiltersMobile, setShowFiltersMobile ] = useState(false)
    const [ mobileMap, setMobileMap ] = useState(false)
    // for list/map toggle
    const [ resultsView, setResultsView ] = useState('list');
    
    // Pagination setup to set page count
    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage   
        setCurrentItems([...contractors].slice(itemOffset, endOffset))
        setNoResultItems([...fullContractorList].slice(itemOffset, endOffset))
        setPageCount(Math.ceil(contractors.length / itemsPerPage))
      }, [itemOffset, itemsPerPage, contractors])

    
    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % contractors.length
        setItemOffset(newOffset)
        }  
    

    useEffect(() => {

        window.addEventListener('scroll', (event) => {
           checkScrollPosition()
        });

        let scrollThreshold = document.querySelector('body').classList.contains('admin-bar') ? 346 : 314;
        let targetElement = document.querySelector('.search-after-wrapper');
        let scrollClass = 'scrolling';

        function checkScrollPosition(){
          if (window.scrollY > scrollThreshold) {
            targetElement.classList.add(scrollClass);
          } else {
            targetElement.classList.remove(scrollClass);
          }
        }
    }, [])

    return (
        <>
            <div className="container">
                <div className="search-page-container" >
                    {/* mobile views search nav*/}
                    <div className="search-nav-mobile">
                        <p className="fac-searchicon-button contractor-new-search-mobile" onClick={e => {
                            e.preventDefault()
                            setShowFiltersMobile(!showFiltersMobile)
                        }}>
                            FILTER
                        </p>
                    </div>
                                    
                    {
                        showModal? 
                        <ContactModal 
                            requestedContractor={requestedContractor} 
                            setShowModal={setShowModal}
                            setOverlay={setOverlay}
                            user={user}
                        /> 
                        : null
                    }

                    <div className="search-after-wrapper container">
                        <div className="search-results-wrapper">
                            <div className={showFiltersMobile ? "search-filter-column-mobile" : "search-filter-column"}>
                                <FACSearchBar
                                    setOverlay={setOverlay} 
                                    setShowContractors={setShowContractors} 
                                    setShowSearch={setShowSearch} 
                                    handleFilters={handleFilters}
                                    handleLocation={handleLocation}
                                    showFiltersMobile={showFiltersMobile}
                                    setShowFiltersMobile={setShowFiltersMobile}
                                />
                            </div>
                            {!showFiltersMobile &&
                                <div className="search-after-container">
                                    <div className="search-result-container">
                                        <div className="toggleExportWrapper">
                                            <div className="mapListToggleContainer">
                                                <button className={`mapListToggleButton ${resultsView == 'list' ? 'active' : ''}`} onClick={() => setResultsView('list')}>List</button>
                                                <button className={`mapListToggleButton ${resultsView == 'map' ? 'active' : ''}`} onClick={() => setResultsView('map')}>Map</button>
                                            </div>
                                            <div className={contractors.length ? "search-filter-container" : "search-filter-container filter-no-results"}>
                                            {contractors.length ? 
                                                <div className="fac-print-export-wrapper">
                                                    <p><strong>{contractors.length} results</strong></p>
                                                    <PrintPdf contractors={contractors} />
                                                    <ExportExcel contractors={contractors} />
                                                </div> : ""}
                                            </div>
                                        </div>
                                        {resultsView == 'map' &&
                                            <div className="search-map-container">
                                                <div className="search-sticky-container">
                                                    <Map
                                                    contractors={contractors}
                                                    user={user}
                                                    />
                                                </div>
                                            </div>
                                        }

                                        {resultsView == 'list' && 
                                            <>
                                                <div className={showContractors? "search-contractor-container" : "search-contractor-container-mobile"}>
                                                    {contractors.length ?
                                                    "" : <div className="no-results-view">
                                                        <img src={noresults} alt="no results" className="no-result-icon" />
                                                        <h2 className="no-result-header">We couldn’t find any matches</h2>
                                                        <p className="no-result-copy">Please try searching for something different like a service, area, or different filters. Or view our contractor list below to find what you need.</p>
                                                    </div>}
                                                    
                                                    <ContractorList 
                                                        setShowModal={setShowModal} 
                                                        setRequestedContractor={setRequestedContractor}
                                                        setOverlay={setOverlay}
                                                        setShowSearch={setShowSearch}
                                                        setShowContractors={setShowContractors}
                                                        mobileMap={mobileMap}
                                                        user={user}
                                                        setMobileMap={setMobileMap}
                                                        contractors={contractors.length ? currentItems : noResultItems}
                                                        fullContractorList={fullContractorList}
                                                    />

                                                        
                                                    <ReactPaginate
                                                        previousLabel={'Prev'}
                                                        nextLabel={'Next'}
                                                        pageRangeDisplayed={5}
                                                        pageCount={pageCount}
                                                        marginPagesDisplayed={0}
                                                        onPageChange={handlePageClick}
                                                        renderOnZeroPageCount={null}
                                                        containerClassName={'pagination'}
                                                        ignoreSinglePage={true}
                                                        activeClassName={'active'}
                                                    />
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                        {showModal ? <div className="dropdown-open" style={{zIndex: "9"}}></div> : ""}
                    </div>
                </div>
            </div>
        </>
    )
}